var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map 1",
    clipPath: "url(#clip0_4872_41828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7396 15.0591L7.44661 11.7271C7.28261 11.6401 7.08261 11.6521 6.92761 11.7571L2.11561 15.0891C1.93561 15.2141 1.85761 15.4411 1.92361 15.6501C1.98761 15.8571 2.18161 16.0001 2.39961 16.0001H13.5046C13.7336 16.0001 13.9346 15.8441 13.9896 15.6201C14.0456 15.3971 13.9416 15.1661 13.7396 15.0591Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8455 14.109L14.3654 7.44602C14.3295 7.28302 14.2144 7.15002 14.0595 7.08902C13.9035 7.02802 13.7284 7.04902 13.5924 7.14302L8.77945 10.475C8.63545 10.575 8.55445 10.742 8.56545 10.915C8.57545 11.09 8.67645 11.246 8.83045 11.327L15.1225 14.659C15.1965 14.698 15.2765 14.718 15.3565 14.718C15.4635 14.718 15.5705 14.684 15.6595 14.615C15.8145 14.497 15.8875 14.3 15.8455 14.109Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3636 6.351C12.2976 6.142 12.1046 6 11.8856 6H7.32156C6.49156 7.503 5.26356 8.94 4.75856 9.502C4.47456 9.818 4.06756 10 3.64256 10C3.21756 10 2.81056 9.818 2.52656 9.502C2.33156 9.285 2.02956 8.938 1.68356 8.508L0.473564 13.954C0.429564 14.155 0.512564 14.362 0.682564 14.477C0.766564 14.534 0.864564 14.562 0.961564 14.562C1.06156 14.562 1.16056 14.533 1.24656 14.473L12.1696 6.91C12.3506 6.787 12.4276 6.56 12.3636 6.351Z",
    fill: "#979EA8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.64258 0C1.71258 0 0.142578 1.57 0.142578 3.5C0.142578 5.296 2.95058 8.477 3.27058 8.834C3.36558 8.939 3.50058 9 3.64258 9C3.78458 9 3.91958 8.939 4.01458 8.834C4.33458 8.477 7.14258 5.296 7.14258 3.5C7.14258 1.57 5.57258 0 3.64258 0ZM3.64258 5C2.81458 5 2.14258 4.328 2.14258 3.5C2.14258 2.672 2.81458 2 3.64258 2C4.47058 2 5.14258 2.672 5.14258 3.5C5.14258 4.328 4.47058 5 3.64258 5Z",
    fill: "#979EA8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_41828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/countryIcon.543960e1e9cfce137385a23f5cfa74a9.svg";
export { ForwardRef as ReactComponent };